export default {
  styleOverrides: {
    icon: {
      color: '#00bc66 !important'
    }
  }
};
